
import axios from '../wmsAxios'

/*
 * 机构管理模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/tStoredItem/save',
        method: 'post',
        data
    })
}

// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/tStoredItem/delete',
        method: 'post',
        data
    })
}

// 查询分页数据
export const findPage = (data) => {
    return axios({
        url: '/tStoredItem/findPage',
        method: 'post',
      data
    })
}

// 查询库存
export const findPageByLocation = (data) => {
  return axios({
    url: '/tStoredItem/findPageByLocation',
    method: 'post',
    data
  })
}

// 查询库存
export const findPageByLocID = (data) => {
  return axios({
    url: '/tStoredItem/findPageByLocID',
    method: 'post',
    data
  })
}

// 查询可用库存数量
export const findAvailableStockQty = (data) => {
  return axios({
    url: '/tStoredItem/findAvailableStockQty',
    method: 'post',
    data
  })
}

// 查询可用库存数量
export const holdReleaseInventory = (data) => {
  return axios({
    url: '/tStoredItem/holdReleaseInventory',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/tStoredItem.js